import { Link } from "gatsby"
import Img from "gatsby-image"
import React from "react"
import { Image } from "semantic-ui-react"
import { formatPrice } from "../../utilities/utilities"

export function ProductCard({
  product,
  collections,
}: {
  product: any
  collections: any
}) {
  let productCollection = "-"
  if (product.collectionIds != null) {
    productCollection = collections.find(
      collection => collection.id === product.collectionIds[0]
    )
  }
  return (
    <>
      <Link to={"/products/" + product.slug}>
        <div className="card product-card card-static pb-3">
          <Image>
            {product.productAsset && (
              <Img
                fluid={product.productAsset.imageFile.childImageSharp.fluid}
                alt={product.productName}
              />
            )}
          </Image>
          {/* <Img
            sizes={product.productPreview.imageFile.childImageSharp.sizes}
            alt={product.productName}
          /> */}

          <div className="card-body py-2">
            <Category collection={productCollection} />
            <h3 className="product-title font-size-sm">
              <a href="grocery-single.html">{product.productName}</a>
            </h3>
            <div className="product-price">
              <span className="">
                <ProductPrice
                  price={product.priceWithTax}
                  currencyCode={product.currencyCode}
                />{" "}
              </span>
            </div>
          </div>
        </div>
      </Link>
    </>
  )
}

function Category({ collection }) {
  return (
    <a className="product-meta d-block font-size-xs pb-1" href="#">
      {(collection && collection.name) || "-"}
    </a>
  )
}

function ProductPrice({ price, currencyCode }) {
  if (price == null) return <div></div>
  if (price.max == 0) return <div>Tarif sur devis</div>
  return (
    <div>
      {price.min !== price.max && "from"} {formatPrice(currencyCode, price.min)}
    </div>
  )
}
